export default {
    primary: '#333333',
    secondary: '#FFFFFF',
    accent: '#E9E9E9',
    accentDarker: '#4b4a4a',
    danger: '#D62F16',
    warning: '#E3DB18',
    success: '#32C040',
};